module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAU1JREFUeNpiYACC0tsW/5lABJD9ACCAQLz1IFEmID4I5CQABBBcBEgrAPF+BihnP1gWCAACiBFmCpByhMmehxkCAgpgZSADoJz9AAHEgAyAEgVINijAXAM2tFv1xAQg3Q/kBoB0s4BsgRp1AWrARCh9HyCAYE5xQLJjA9CEQAZk85HthAGQU+cDVT6AKohHctx6kGQjVEc+UJEhzIEgR4EkFUCuBHGAEu+BdCFMNyNUpSKIAzUeFDQgBykgB1wiOPQZGOpBbJBCgABtUgENwCAMyxwg4XeAhSu4lEu4hkvAwe4AJ0cCEr4mHVkISxoIg63tkEAAhD5DNRRDYqqTKOTueOQtXf84jFOBgEXxQwKVk3Z3ulx4H90yGajhhW0+5ganDcIiiZQr99AlnEZz05WiPW5+kUxsi7xG7mNdxXxHpiSMuqg1Bjo8RrX6wQ+3gZS1THW83wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/icon/yjz.png
// module id = LS5c
// module chunks = 1